import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ScimApiKey } from '../../../models';
import { ScimActions } from '../../../store/actions';
import { ScimSelectors } from '../../../store/selectors';
import { AbstractIdentityConfigService } from '../../abstract-identity-config/abstract-identity-config.service';
import { ActionDispatcherService } from '@anecdotes/shared-infra';
import { v4 } from 'uuid';

@Injectable()
export class ScimFacade {
  constructor(
    private store: Store,
    protected configService: AbstractIdentityConfigService,
    private actionDispatcher: ActionDispatcherService
  ) {}

  load(): void {
    this.store.dispatch(ScimActions.Load());
  }

  isLoading(): Observable<boolean> {
    return this.store.select(ScimSelectors.isLoading);
  }

  getAll(): Observable<ScimApiKey[]> {
    return this.store.select(ScimSelectors.selectAll);
  }

  getById(keyId: string): Observable<ScimApiKey> {
    return this.store.select(ScimSelectors.selectById(keyId));
  }

  getIdentityUrl(): string {
    return this.configService.getConfig().identityApi.baseUrl + this.configService.getConfig().identityApi.endpoints.scim;
  }

  async generateApiKeyAsync(keyName: string = v4()): Promise<ScimApiKey> {
    const scimApiKey: ScimApiKey = await this.actionDispatcher.dispatchActionAsync(ScimActions.Generate({ keyName }), ScimActions.Generate.type);
    return scimApiKey;
  }

  async revoke(keyId: string): Promise<void> {
    await this.actionDispatcher.dispatchActionAsync(
      ScimActions.Revoke({ apiKeyId: keyId }),
      ScimActions.Revoke.type
    );
  }
}
